/* eslint-disable no-unused-vars */
import { all } from 'redux-saga/effects';
import authSagas from './auth/saga';
import user from './user/saga';
import upload from './upload/saga';
import request from './request/saga';
import request_detail from './request_detail/saga';
import equipment_schedule_maintenance from './equipment_schedule_maintenance/saga';
import search from './search/saga';

export default function* rootSaga(getState) {
  yield all([
    authSagas(),
    user(),
    upload(),
    request(),
    request_detail(),
    equipment_schedule_maintenance(),
    search()
  ]);
}
